import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GermplasmService } from '../../../shared/germplasm/service/germplasm.service';
import { HttpResponse } from '@angular/common/http';
import { JhiLanguageService } from '../../../shared/core-utils';
import { TranslateService } from '@ngx-translate/core';
import { GermplasmDto } from '../../../shared/germplasm/model/germplasm.model';
import { AlertService } from '../../../shared/alert/alert.service';

@Component({
    selector: 'jhi-inventory-details-main',
    templateUrl: './inventory-details-main.component.html'
})
export class InventoryDetailsMainComponent implements OnInit {

    gid: number;
    title: String;

    constructor(private jhiLanguageService: JhiLanguageService,
                private activeModal: NgbActiveModal,
                private route: ActivatedRoute,
                private germplasmService: GermplasmService,
                private alertService: AlertService,
                private translateService: TranslateService,
    ) {
        this.route.queryParams.subscribe((value) => {
            this.gid = value.gid;
            this.germplasmService.getGermplasmById(this.gid).subscribe(
                (res: HttpResponse<GermplasmDto>) => this.onSuccess(res.body)
            );
        });
    }

    ngOnInit() {

    }

    private onSuccess(data: GermplasmDto) {
        this.title = this.translateService.instant('inventory-details.title',
            { param1: data.preferredName, param2: this.gid });
    }

    cancel() {
        this.activeModal.dismiss();
        if ((<any>window.parent).closeModal) {
            (<any>window.parent).closeModal();
        }
    }

}
